import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { MatInputModule, MatButtonModule } from '@angular/material';

// =====================
// | | | Modules
// =====================
import { AppRoutingModule } from './app.routes'; 

// =====================
// | | | Components 
// =====================
import { AppComponent } from './app.component';
import { HomeComponent } from './components/home/home.component';
import { ScheduleComponent } from './components/schedule/schedule.component';
import { PrivateLessonsComponent } from './components/private-lessons/private-lessons.component';
import { TeamComponent } from './components/team/team.component';
import { ClassesComponent } from './components/classes/classes.component';
import { BoxingComponent } from './components/boxing/boxing.component';
import { TaekwondoComponent } from './components/taekwondo/taekwondo.component';
import { MuayThaiComponent } from './components/muay-thai/muay-thai.component';
import { EscrimaKaliComponent } from './components/escrima-kali/escrima-kali.component';
import { KidsClassesComponent } from './components/kids-classes/kids-classes.component';
import { SparringComponent } from './components/sparring/sparring.component';
import { CardioKickboxingComponent } from './components/cardio-kickboxing/cardio-kickboxing.component';
import { NavComponent } from './components/nav/nav.component';
import { FooterComponent } from './components/footer/footer.component';

// =====================
// | | | Services 
// =====================
import { ApiService } from './services/api.service';
import { BrazilianJiuJitsuComponent } from './components/brazilian-jiu-jitsu/brazilian-jiu-jitsu.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    ScheduleComponent,
    TeamComponent,
    ClassesComponent,
    BoxingComponent,
    TaekwondoComponent,
    MuayThaiComponent,
    EscrimaKaliComponent,
    KidsClassesComponent,
    SparringComponent,
    CardioKickboxingComponent,
    FooterComponent,
    NavComponent,
    BrazilianJiuJitsuComponent,
    PrivateLessonsComponent
  ],
  imports: [
    AppRoutingModule,
    HttpClientModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MatInputModule,
    MatButtonModule
  ],
  providers: [ApiService],
  bootstrap: [AppComponent]
})

export class AppModule { }
